module.exports = __webpack_public_path__ + "static/media/main idea.95f37110.mp3";